module.exports = __webpack_public_path__ + "5546eddd274ea15e8d6a1361f72a5a70.png";